import gql from 'graphql-tag';

const EXECUTED_SCRIPTS_LIST = gql`
  query($listInfo: ListInfoInput!) {
    getExecutedScriptList(listInfo: $listInfo) {
      executedScriptData {
        actionId
        statusMessage
        completedTime
        createdTime
        executionStatus
        isTestExecution
        script {
          scriptId
          name
          language
          custom
        }
        asset {
          assetId
          name
          assetClass {
            classId
            name
            iconClass
          }
          client {
            name
            accountId
          }
        }
        origin {
          source
          id
          name
        }
      }
      listInfo {
        page
        pageSize
        totalCount
        condition
        sort {
          attribute
          order
        }
        hasMore
      }
    }
  }
`;

const EXECUTED_SCRIPTS_TABLE_META = gql`
  query {
    getExecutedScriptListMetaInfo
  }
`;

const EXECUTED_SCRIPTS_ACTIONS = gql`
  query($actionId: ID!) {
    getActionDetails(actionId: $actionId) {
      scriptArguments
      addedBy {
        name
      }
      policy {
        name
      }
      origin {
        source
        id
        name
      }
    }
  }
`;

export {
  EXECUTED_SCRIPTS_LIST,
  EXECUTED_SCRIPTS_TABLE_META,
  EXECUTED_SCRIPTS_ACTIONS
};
